module.exports = __webpack_public_path__ + "02_long_black.0c2a4eeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_long_black.png
// module id = YlGX
// module chunks = 0